import i18n from "../../i18n/i18n"

function LanguageSwitcher() {

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
   localStorage.setItem("language", lng)
  }

  return (
    <div>
      <button onClick={() => changeLanguage("en")}>
        EN
      </button>

      <button onClick={() => changeLanguage("de")}>
        DE
      </button>
    </div>
  )
}

export default LanguageSwitcher